import settings from "../../../configs/settings";
import { Grid, IconButton, Paper, Tooltip, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import PublishedWithChangesOutlinedIcon from '@mui/icons-material/PublishedWithChangesOutlined';
import GestionAtencionContext from "../../../project/contexts/GestionAtencionContext";
import { useContext, useState } from "react";
import AnteojoEstadoDialog from "./AnteojoEstadoDialog";
import Message from "../../../project/utils/Message";
import { formatMoney } from "../../utils/utils"
//
// ################################################################################
//
const AnteojoTable = () => {
  const [openAnteojoEstadoDialog, setOpenAnteojoEstadoDialog] = useState(false);
  const [idAnteojo, setIdAnteojo] = useState("");
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const {
    anteojos,
    anteojosSelected,
    obtenerAnteojo,
    quitarAnteojo,
    anteojoAction,
    seleccionarAnteojos,
    totalAnteojos,
    totalAnteojosContado,
    showCheckBoxesAnteojosRows,
    showActionsAnteojosRows,
    showImportesContado,
    gaAction,
  } = useContext(GestionAtencionContext);

  const tableColumns = [
    {
      field: "codigoAnteojo",
      headerName: "Código",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.codigoAnteojo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "cristalesTipoAnteojo",
      headerName: "Tipo Anteojo",
      headerAlign: "center",
      align: "center",
      flex: 1.5,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.cristalesTipoAnteojo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "anteojoTableDescripcion",
      headerName: "Armazón",
      headerAlign: "center",
      align: "left",
      flex: 3,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.anteojoTableDescripcion;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "cristalDescripcionOD",
      headerName: "Cristal OD",
      headerAlign: "center",
      align: "left",
      flex: 3,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.cristalDescripcionOD;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "cristalDescripcionOI",
      headerName: "Cristal OI",
      headerAlign: "center",
      align: "left",
      flex: 3,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.cristalDescripcionOI;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "totalAnteojo",
      headerName: "Sub Lista",
      headerAlign: "center",
      align: "right",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.totalAnteojo;
        _val = _val ? _val : 0;
        return _val.toFixed(2);
      },
    },
    {
      field: "totalAnteojoContado",
      headerName: "Sub Contado",
      headerAlign: "center",
      align: "right",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.totalAnteojoContado;
        _val = _val ? _val : 0;
        return _val.toFixed(2);
      },
    },
    {
      field: "actions",
      headerName: "Acciones",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <>
          {gaAction.cu === "view" && (
            <>
              <Tooltip title="ver anteojo">
                <IconButton
                  size="small"
                  aria-label="update"
                  onClick={() => obtenerAnteojo(params.row, "view")}
                >
                  <RemoveRedEyeOutlinedIcon />
                </IconButton>
              </Tooltip>
            </>
          )}

          {gaAction.cu !== "view" && showActionsAnteojosRows && (
            <>
              {anteojoAction.cu === "new" ? (
                <>
                  {/* si puedo crear un anteojo, muestro los botones de actualizar y quitar
                    los anteojos que ya tengo en la ga */}
                  <Tooltip title="atualizar">
                    <IconButton
                      size="small"
                      aria-label="update"
                      onClick={() => obtenerAnteojo(params.row, "update")}
                    >
                      <EditOutlinedIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="quitar">
                    <IconButton
                      size="small"
                      aria-label="delete"
                      onClick={() => quitarAnteojo(params.row)}
                    >
                      <RemoveCircleOutlineIcon />
                    </IconButton>
                  </Tooltip>
                </>
              ) : (
                <>
                  {/* si estoy editando un anteojo que ya tengo en la table deshabilito los botones
                    de editar y quitar */}
                  <IconButton size="small" disabled={true} aria-label="update">
                    <EditOutlinedIcon />
                  </IconButton>
                  <IconButton size="small" disabled={true} aria-label="delete">
                    <RemoveCircleOutlineIcon />
                  </IconButton>
                </>
              )}
            </>
          )}

          {gaAction.cu === "view" &&
            params.row.actionEstadoAnteojo === "venta-concretada" && (
              <>
                <Tooltip title="estado del anteojo">
                  <IconButton
                    size="small"
                    aria-label="update"
                    onClick={() => handleClickAnteojoEstado(params.row)}
                  >
                    <PublishedWithChangesOutlinedIcon />
                  </IconButton>
                </Tooltip>
              </>
            )}
        </>
      ),
    },
  ];

  const tableOptions = {
    disableRowSelectionOnClick: true,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    localeText: {
      noRowsLabel: "",
      noResultsOverlayLabel: "",
    },
    sx: {
      "& .MuiDataGrid-cell": {
        fontSize: "0.9em",
      },
      "& .MuiDataGrid-columnHeaders": {
        backgroundColor: "#f5f5f5",
      },
    },
  };
  //
  // ################################################################################
  //
  const handleClickAnteojoEstado = (parRow) => {
    setIdAnteojo(parRow.id);
    setOpenAnteojoEstadoDialog(true);
  }
  //
  // ################################################################################
  //
  return (
    <>
      <Paper elevation={3} sx={{ m: 1, p: 2 }}>
        <DataGrid
          rows={anteojos}
          columns={tableColumns}
          {...tableOptions}
          checkboxSelection={showCheckBoxesAnteojosRows}
          rowSelectionModel={showCheckBoxesAnteojosRows ? anteojosSelected : []}
          onRowSelectionModelChange={(newSelection) => {
            seleccionarAnteojos(newSelection);
          }}
          hideFooter
        />

        <Grid container spacing={1}>
          <Grid item sm={showImportesContado ? 6 : 12}>
            <Typography
              component="div"
              align="right"
              sx={{
                p: 1,
                mt: 2,
                backgroundColor: "SteelBlue",
                borderRadius: "5px",
                fontSize: "1.1rem",
                fontWeight: "bold",
              }}
            >
              TOTAL DE LISTA: {formatMoney(totalAnteojos)}
            </Typography>
          </Grid>

          {showImportesContado ? (
            <>
              <Grid item sm={6}>
                <Typography
                  component="div"
                  align="right"
                  sx={{
                    p: 1,
                    mt: 2,
                    backgroundColor: "SteelBlue",
                    borderRadius: "5px",
                    fontSize: "1.1rem",
                    fontWeight: "bold",
                  }}
                >
                  TOTAL DE CONTADO: {formatMoney(totalAnteojosContado)}
                </Typography>
              </Grid>
            </>
          ) : null}
        </Grid>
      </Paper >

      {/* >>>> Dialog */}

      {
        openAnteojoEstadoDialog && (
          <AnteojoEstadoDialog
            idGestionAtencionAnteojo={idAnteojo}
            onClose={() => setOpenAnteojoEstadoDialog(false)}
            setMessage={setMessage}
            setShowMessage={setShowMessage}
          />
        )
      }

      {/* >>>> Messages */}

      {
        showMessage && (
          <Message
            showMessage={showMessage}
            setShowMessage={setShowMessage}
            message={message}
          />
        )
      }
    </>
  );
};
export default AnteojoTable;